var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "m-0 mt-2" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "validation-observer",
                    { ref: "requestForm" },
                    [
                      _c(
                        "b-form",
                        {
                          staticClass: "mb-1 mt-2",
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.saveForm($event)
                            }
                          }
                        },
                        [
                          _c("h4", { staticClass: "mt-2 mb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm._.get(_vm.dataForm, "type_form_str", "")
                              )
                            )
                          ]),
                          _c("vs-divider"),
                          _vm.typeForm === "CA"
                            ? _c("RequestFormIncidentCoupAttempt", {
                                ref: "coupAttempt",
                                attrs: {
                                  typeForm: _vm.typeForm,
                                  dataForm: _vm.dataForm,
                                  disabledFields: _vm.disabledFields
                                }
                              })
                            : _vm._e(),
                          _vm.typeForm === "GE"
                            ? _c("RequestFormIncidentGeneral", {
                                ref: "general",
                                attrs: {
                                  typeForm: _vm.typeForm,
                                  dataForm: _vm.dataForm,
                                  disabledFields: _vm.disabledFields
                                }
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "vx-row pt-2" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "incident_form_attachments"
                                      ),
                                      "label-for": "incident_form_attachments"
                                    }
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: _vm.$t(
                                          "incident_form_attachments"
                                        )
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-file", {
                                                attrs: {
                                                  id: "attachments",
                                                  placeholder:
                                                    "Clique para selecionar os arquivos ou arraste aqui...",
                                                  "drop-placeholder":
                                                    "Solte os arquivos aqui...",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                  name: "generalAttachments",
                                                  disabled: _vm.disabledFields,
                                                  multiple: "",
                                                  accept:
                                                    ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                                                },
                                                on: {
                                                  input:
                                                    _vm.appendGeneralAttachments
                                                },
                                                model: {
                                                  value:
                                                    _vm.newGeneralAttachments,
                                                  callback: function($$v) {
                                                    _vm.newGeneralAttachments = $$v
                                                  },
                                                  expression:
                                                    "newGeneralAttachments"
                                                }
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "feather icon-upload mr-1"
                                                  }),
                                                  _vm._v(
                                                    " Selecione um ou mais arquivos para anexar. Todos os anexos sao opcionais. "
                                                  )
                                                ]
                                              ),
                                              _vm.generalAttachments &&
                                              _vm.generalAttachments.length
                                                ? _c(
                                                    "div",
                                                    { staticClass: "mt-2" },
                                                    [
                                                      _c(
                                                        "b-list-group",
                                                        _vm._l(
                                                          _vm.generalAttachments,
                                                          function(file, idx) {
                                                            return _c(
                                                              "b-list-group-item",
                                                              {
                                                                key:
                                                                  _vm.getFileName(
                                                                    file
                                                                  ) +
                                                                  "-" +
                                                                  idx,
                                                                staticClass:
                                                                  "d-flex justify-content-between align-items-center"
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "feather icon-file-text text-primary mr-2"
                                                                  }),
                                                                  _vm.getDownloadUrl(
                                                                    file
                                                                  )
                                                                    ? _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2 download-link text-primary",
                                                                          attrs: {
                                                                            href: _vm.getDownloadUrl(
                                                                              file
                                                                            ),
                                                                            target:
                                                                              "_blank",
                                                                            title:
                                                                              "Baixar arquivo"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "feather icon-download"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getFileName(
                                                                          file
                                                                        )
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm.getFileSize(
                                                                    file
                                                                  )
                                                                    ? _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "ml-2 text-muted"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " (" +
                                                                              _vm._s(
                                                                                _vm.formatFileSize(
                                                                                  _vm.getFileSize(
                                                                                    file
                                                                                  )
                                                                                )
                                                                              ) +
                                                                              ") "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]),
                                                                !_vm.disabledFields
                                                                  ? _c(
                                                                      "b-button",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            "outline-danger",
                                                                          size:
                                                                            "sm"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeAttachment(
                                                                              idx
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "feather icon-trash-2"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ])
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "mt-1 mb-2" }, [
                            _c(
                              "div",
                              { staticClass: "flex justify-end" },
                              [
                                !_vm.disabledFields
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "ripple",
                                            rawName: "v-ripple.400",
                                            value: "rgba(255, 255, 255, 0.15)",
                                            expression:
                                              "'rgba(255, 255, 255, 0.15)'",
                                            modifiers: { "400": true }
                                          }
                                        ],
                                        staticClass: "mt-1 mr-1 float-right",
                                        attrs: {
                                          variant: "primary",
                                          disabled: !_vm.validateForm
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveForm()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("save")) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "ripple",
                                        rawName: "v-ripple.400",
                                        value: "rgba(255, 255, 255, 0.15)",
                                        expression:
                                          "'rgba(255, 255, 255, 0.15)'",
                                        modifiers: { "400": true }
                                      }
                                    ],
                                    staticClass: "mt-1 mr-1 float-right",
                                    attrs: { variant: "outline-secondary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push(
                                          "/incident-form"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }